import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "./E3ReactTab.module.css";

/**
 * E3ReactTab
 * @type React.FC<E3ReactTabPropTypes>
 */
const E3ReactTab = React.forwardRef((props, ref) => {
  Object.keys(props).forEach((p) => {
    if (!Object.keys(E3ReactTabPropTypes).includes(p)) {
      console.error(`E3ReactTab: 정의되지 않은 prop ${p}가 전달되었습니다.`);
    }
  });

  const refTabPanel = useRef();

  useEffect(() => {
    setCurrState((prev) => ({
      ...prev,
      tabs: props.tabs,
    }));
  }, [props.tabs]);

  /** 외부에서 접근할 수 있는 함수들 */
  React.useImperativeHandle(ref, () => ({
    setSelectedIndex(index) {
      setCurrState((prev) => ({
        ...prev,
        selectedIndex: index,
      }));
    },

    getSelectIndex() {
      return currState.selectedIndex;
    },

    /**
     * indes 번의 Tab 활성 | 비활성 화 함수
     * - value `true` 비활성화
     * - value `false` 활성화
     * @param {number} index
     * @param {boolean} value
     */
    setTabDisabledByIndex(index, value = false) {
      setCurrState((prev) => ({
        ...prev,
        tabs: prev.tabs?.map((item, _index) =>
          _index === index ? { ...item, disabled: value } : item
        ),
      }));
    },
  }));

  const [currState, setCurrState] = useState({
    tabs: props.tabs.map((item) => ({ ...item, disabled: false })),
    selectedIndex: props.selectedIndex ?? 0,
    forceRender: props.forceRender ?? true,
    focusTab: props.focusTab,
  });

  const selectedIndexChanged = (idx) => {
    setCurrState((prev) => ({
      ...prev,
      selectedIndex: idx,
    }));
  };

  const _onSelect = (idx, lastIdx, e) => {
    selectedIndexChanged(idx);
    if (props.onSelect) props.onSelect(idx, lastIdx, e);
  };

  const _init = (e) => {
    refTabPanel.current = e;
  };

  return currState.tabs?.length ? (
    <div>
      <Tabs
        domRef={_init}
        onSelect={_onSelect}
        forceRenderTabPanel={currState.forceRender}
        selectedIndex={currState.selectedIndex}
        className={styles.tabsBelow}
        focusTabOnClick={currState.focusTab}
      >
        <TabList>
          {currState.tabs?.map((item, idx) => {
            return (
              <Tab
                key={
                  Math.random()
                    .toString(36)
                    .replace(/[^a-z]+/g, "")
                    .substr(0, 5) +
                  `_` +
                  idx
                }
                disabled={item.disabled}
              >
                {item.header}
              </Tab>
            );
          })}
        </TabList>

        {currState.tabs?.map((item, idx) => {
          return <TabPanel key={`tabPanel_ + ${idx}`}>{item.content}</TabPanel>;
        })}
      </Tabs>
    </div>
  ) : null;
});

const E3ReactTabPropTypes = {
  tabs: PropTypes.array,
  selectedIndex: PropTypes.number,
  forceRender: PropTypes.bool,
  onSelect: PropTypes.func,
  focusTab: PropTypes.bool,
};
E3ReactTab.propTypes = E3ReactTabPropTypes;
E3ReactTab.defaultProps = {
  tabs: [],
  selectedIndex: 0,
  forceRender: true,
  onSelect: null,
  focusTab: false,
};
E3ReactTab.displayName = "E3ReactTab";

export default E3ReactTab;
